window.addEventListener('load', function () {
    const container = document.querySelector('[data-countdown-element]');
    if (!container) return;

    const valueEl = container.querySelector('[data-countdown-value]');
    if (!valueEl) return;

    // Preferred: pass total seconds via data-remaining-seconds
    let remaining = parseInt(container.dataset.remainingSeconds, 10);

    // Fallback: parse HH:MM:SS if needed
    if (isNaN(remaining)) {
        const hms = (container.dataset.countdownElement || '').trim();
        const parts = hms.split(':').map(Number);
        if (parts.length === 3 && parts.every(n => Number.isFinite(n))) {
            remaining = parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else {
            return;
        }
    }

    const pad = n => (n < 10 ? `0${n}` : `${n}`);
    const formatHMS = s => {
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        return `${pad(h)}:${pad(m)}:${pad(sec)}`;
    };

    function tick() {
        if (remaining <= 0) {
            valueEl.textContent = '00:00:00';
            clearInterval(interval);
            window.location.reload();
            return;
        }
        valueEl.textContent = formatHMS(remaining);
        remaining -= 1;
    }

    tick();
    const interval = setInterval(tick, 1000);
});
